import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import ContentWrapper from '../components/content-wrapper';
import Result from '../components/result';
import TabGroup, {
    PictureSection,
    TablePanel,
    TitledSection,
} from '../components/tab-group';
import { connect } from 'react-redux';
import {
    translateFaceDiagnosisResult,
    translateTongueDiagnosisResult,
} from '../sagas/util';
import MusicPlayer from '../components/music-player';
import { changeTitle, queryObject } from '../util';

import DoctorAnnouncement from '../components/doctor-announcement';
import { replace } from 'connected-react-router';
import HealthSymptoms from '../components/health-symptoms';
import ClassicPrescription2 from '../components/classic-prescription2';
import PictureGrid from '../components/picture-grid';
import { changeMusicPlayAction } from '../actions/music-player';
import ReportHeader from '../components/report-header';
import { Gap, GapPageBreaker } from '../components/gap';
import SectionHeader from '../components/section-header';
import UserInfo from '../components/user-info';
import SimpleTable from '../components/simple-table';
import Indicator from '../components/indicator';
import SymptomSummary from '../components/SymptomSummary';
import ReportFooter from '../components/report-footer';
import { TextContent, TitlelessTextContent } from '../components/text-content';
import ClassicScript from '../components/classic-script';

import rsyw from '../assets/img/rsyw_jdyf_icon@3x.png';
import rsywMock from '../assets/img/rsyw-text-mock.png';
import qlpp from '../assets/img/qlpp_jdyf_icon@3x.png';
import qlppMock from '../assets/img/qlpp-text-mock.png';
import bandAd from '../assets/img/band-ad.jpeg';
import bandAdHeader from '../assets/img/band-ad-header.png';
import {refreshUserInfo} from "../actions/user";
import {appointmentinfo} from "../actions/result-history";

const StretchableContentWrapper = styled(ContentWrapper)`
  min-height: 100%;
  height: auto;
  position:relative;
  @media print {
    background: none;
  }
`;
const Topcolome = styled.div`
 background-color:white;
 color:#333333;
 width:100%;
 padding-top:15px;
 height:100px;
 text-align:center;
 font-size:50px;
`;
const PictureGridWrapper = styled.div`
  margin: 0 auto 6px 80px;
  
  @media print {
    margin: 0 auto 6px 40px;
  }
`;
const List = styled.div`
 width:100%;
 height:195px;
 background-color:white;
 border-top:0.5px solid #f6f5fa;
 position:relative;
`;
const VideoWrapper = styled.div`
  margin: 30px 40px;
  
  &.prism-fullscreen {
    margin: 0;
  }
`;
const Div1 = styled.div`
 display:inline-block;
   position:absolute;
  left:171px;
  bottom:50px;
`;
const Icon = styled.img`
  display:inline-block;
  width: 125px;
  height: 125px;
  vertical-align: middle;
  margin:40px 20px 30px 30px;
`;
const Insert = styled.span`
  float:right;
  margin:68px 30px 68px 0px;
  display:inline-block;
  width:140px;
  height:56px;
  border:0.3px solid #22a7f0;
  font-size:28px;
  font-family:PingFangSc-Regular;
  color:#22a7f0;
  text-align:center;
  padding-top:6px;
`;
const DoactorName = styled.span`
  display:block;
  margin-bottom:20px;
  color:#333333;
  font-size:32px;
  font-family:PingFangSc-Regular;
`;
const Time = styled.span`
   display:block;
  color:#ff8a5f;
  font-size:26px;
  font-family:PingFangSc-Regular;
`;
class Appointment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            result1:{}
        };
        this.healthKey = '健康';
        this.getappointment=this.getappointment.bind(this)
        this.doappoin=this.doappoin.bind(this)
        this.cancelappoin=this.cancelappoin.bind(this)
    }
    componentDidMount() {
        // fixme dirty fix of refreshing on history report page
        const { props } = this;
        const { dispatch, orgCode } = this.props;
        // if (!this.props.loggedin) {componentDidMount
        //     this.props.dispatch(refreshUserInfo());
        // }

 this.getappointment(orgCode)
    }
    getappointment(orgCode){
        fetch('http://zhiyunapi.shylsoft.com/zhiyun-api/api/m/televist/ghList', {
            method: 'POST',
            dataType:'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }, body: JSON.stringify({
                orgCode: orgCode,
                memberId: 77,
                page:1,
                limit:30,
                appointmentFlag:1,
            })
        }).then(res => res.json()).then((res) => {
                this.setState({
                    //改变加载ListView
                    activeTab: 1,
                    //设置数据源刷新界面
                    result1: res.data,
                })

            }
        )
    }
    doappoin(e){
        fetch('http://zhiyunapi.shylsoft.com/zhiyun-api/api/m/televist/addPatientQueue', {
            method: 'POST',
            dataType:'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }, body: JSON.stringify({
                appointmentId: e,
                memberId: 77,
            })
        }).then(res => res.json()).then((res) => {
            alert('恭喜您！挂号成功！')
            window.location.reload(true);

            }
        )
    }
    cancelappoin(e){
        fetch('http://zhiyunapi.shylsoft.com/zhiyun-api/api/m/televist/cancelPatientQueue', {
            method: 'POST',
            dataType:'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }, body: JSON.stringify({
                appointmentId: e,
                memberId: 77,
            })
        }).then(res => res.json()).then((res) => {
            alert('取消成功')
                window.location.reload(true);

            }
        )
    }
    appoinment1(e)
        {
        return(
            <List>

                <Icon src={e.doctorHeaderUrl} />
                <Div1  >
                    <DoactorName>
                        {e.doctorName}医生
                    </DoactorName>

                    <Time>
                        {e.appointmentDate}&nbsp;&nbsp;{e.appointmentWeek}&nbsp;&nbsp;{e.appointmentBeginTime}~{e.appointmentEndTime}
                    </Time>
                </Div1>
                {e.yyFlag==='N'? <Insert  onClick={this.doappoin.bind(this,e.id)}  >
                    挂号
                </Insert>:<Insert  onClick={this.cancelappoin.bind(this,e.id)}  >
                    取消
                </Insert>   }

            </List>
        )
    }
    render() {
        const { list } = this.state.result1
        const  { activeTab } = this.state
        if (activeTab===0) return null;
        return(
            <StretchableContentWrapper>
                <Topcolome>挂号 </Topcolome>
                { list[0]  ?  [list.map((e) => (
                // eslint-disable-next-line react/no-array-index-key

                this.appoinment1(e)

                ))]
                 : <List  >暂时没有可预约的医生</List>}

            </StretchableContentWrapper>
        )
    }
}

Appointment.defaultProps = {
    id: null,
};

Appointment.propTypes = {
    result: PropTypes.object.isRequired,
    id: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    musicPlay: PropTypes.bool.isRequired,
};

const mapStatesToProps = (state, props) => ({
    result: props.id ? { examination: state.resultHistory.records[props.id] } : state.result,
    musicPlay: state.musicPlayer.play,
});

export default connect(mapStatesToProps)(Appointment);



// WEBPACK FOOTER //
// ./src/scene/appointment.jsx